import { yupResolver } from "@hookform/resolvers/yup";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { AppQuill } from "../../../../../Component/Common/Components/FormValidationInputs/AppQuill";
import { disputeResolutionsSchema } from "../DisputeResolutions/DisputeResolutionsValidation";
import { DisputeResolutionsService } from "../../../../../Component/Api/EmploymentEquity/Plan/Dispute Resolutions/DisputeResolutionsService";
import { DisputeResolutionsDto } from "../../../../../Component/Model/Dto/EmploymentEquity/Plan/EEDisputeResolutions";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { EEScorecardAtom } from "../../../../../State/EEScorecard.Atom";
import { ConsolidationAtom } from "../../../../../State/Consolidation.Atom";
import { UserActivityService } from "../../../../../Component/Api/UserActivity/UserActivityService";
import { DisputeResolutionsSection } from "../../../../../Component/Common/Constants/UserActivityTrackingSections";
import { UserActivityActionType } from "../../../../../Component/Model/Enum/BEE123Enums";

interface IProps {
    scorecardId : string;
}

type InputForm = {
    detail?: string;
}

export const DisputeResolutions: FC<IProps> = (props) => {

    const scorecard = useRecoilValue(EEScorecardAtom);
    const isConsolidatedScorecard = useRecoilValue(ConsolidationAtom);
    const maxConsolidatedDetailLength = 6000 * (scorecard.ConsolidationSourceScorecardsCount ?? 1);
    const maxDetailLength = isConsolidatedScorecard ? maxConsolidatedDetailLength : 6000;

    const { control, reset, getValues } = useForm<InputForm>({
        mode: 'all',
        resolver: yupResolver(disputeResolutionsSchema(maxDetailLength))
    });

    const getDisputeResolutionsData = async (scorecardId: string) => {
        try {
            const dataResponse = await DisputeResolutionsService.GetDisputeResolutionsInformation(scorecardId);
            const formData: InputForm = {
                detail: dataResponse.data.detail
            }
            reset(formData);
        } catch (error: any) {
            console.log(error);
        }
    }

    const saveDisputeResolutionsForm = async () => {
        const formData = getValues();

        disputeResolutionsSchema(maxDetailLength).validate(formData, { abortEarly: false }).then(async() => {
            const requestData: DisputeResolutionsDto.DisputeResolutionsDto = {
                scorecardId: props.scorecardId,
                detail: formData.detail
            }
            const response = await DisputeResolutionsService.SaveDisputeResolutionsInformation(requestData);
        }).catch(function (error: any) {
            toast.error(error.message);
        });
    }

    const disputeResolutionsLog = (actionType: number, actionDescription: string) => {
        UserActivityService.createActivityLog({
            section: DisputeResolutionsSection,
            actionType: actionType,
            actionDescription: actionDescription,
            scorecardId: props.scorecardId,
            requestUrl: window.location.href
        });
    }
    
    useEffect(() => {
        getDisputeResolutionsData(props.scorecardId);
        disputeResolutionsLog(UserActivityActionType.View, "View dispute resolution commentary");

        return () => {
            if (localStorage.getItem('coreToken') !== null) {
                saveDisputeResolutionsForm();
                disputeResolutionsLog(UserActivityActionType.Create, "Capture dispute resolution commentary");
            }
        }
    }, [props.scorecardId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box component="form" mt={2}>
            <Box>
                <AppQuill control={control} name='detail' label='Detail*' maxLength={maxDetailLength} />
            </Box>
        </Box>
    )
}